export const mutations = {
  STORE_INTERCHANGES(state, interchanges) {
    state.interchanges = interchanges;
  }
};
export default mutations;



// WEBPACK FOOTER //
// ./src/vuex/modules/interchanges/mutations.js